module.exports = __webpack_public_path__ + "assets/img/title_light_pool.bdb308b5.png";